import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', () => {
  const activeRequests = ref(0);

  const isLoading = computed(() => activeRequests.value > 0);

  function start() {
    activeRequests.value += 1;
  }

  function finish() {
    activeRequests.value = Math.max(0, activeRequests.value - 1);
  }

  return {
    activeRequests,
    isLoading,
    start,
    finish,
  };
});